<template>
  <div class="container">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <van-list>
      <div class="list-box">
        <div class="list" @click="changePage(item)" :key="index" v-for="(item,index) in projectList">
          <div class="text-overflow"><span>{{item.name}}</span></div>
          <div><img class="list-arrow" src="../assets/img/sel_right.png" alt=""></div>
        </div>
        <div v-if="showTip" class="noData">暂无数据</div>
      </div>
    </van-list>  
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Toast,Loading,Button,List} from 'vant';
  export default {
    data() {
      return {
        title:'',
        code:'',
        allCount:0,
        pageIndex:1,
        pageSize:10,
        loading: false,
        finished:false,
        showTip:false,
        projectList:[],
        imgDomain:'https://soonsmart.keji.io/',
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Button.name]:Button,
      [List.name]:List,
    },
    methods: {
      changePage(item){
        if(item.contentType == 2){
          var url = item.fileUrl;
          if(url){
            window.location.href= url;
          }
        }else{
          this.$router.push({path: "helpDetail.html",query:{rowId:item.id}})
        }
      },
      getUrlParam (name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let r = (window.location.search.substr(1) || window.location.hash.split('?')[1])['match'](reg)
        if (r != null) return decodeURI(unescape(r[2]))
        else return null
      },
      onSubmit(values) {
        console.log('submit', values);
      },
      getProjectList() {
        axios.get("/techsupport/gettechsupportlist?code="+this.code).then((res)=>{
          this.projectList = res.data;
          if(res.data.length == 0){
            this.showTip = true;
          }else{
            this.projectList.forEach(item => {
              if(item.contentType == 2){
                axios.get("/techsupport/getnoticedetailbyid?id="+item.id,{
                }).then((res)=>{
                  item.fileUrl = this.imgDomain + res.data.content
                })
              }
            });
          }
        })
      },
      onClickLeft() {
        this.$router.go(-1);
      },
    },
    computed:{
    },
    created () {
      this.code = this.$route.query.code;
      this.title = this.$route.query.title;
      this.getProjectList();
    },
    mounted () {},
    destroyed () {}
  }
</script>

<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
  }
  .text-overflow{
    width: 300px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
  }
  .list-box{
    width: 100%;
    .list{
      height: 60px;
      line-height: 60px;
      width: 100%;
      background: #fff;
      margin: 6px 0;
      padding: 0 15px;
      border-bottom: 1px solid #ECEDEE;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .list-arrow{
        width: 10px;
        vertical-align: middle;
      }
    }
  }
  .noData {
    color: #999;
    font-size: 28rpx;
    line-height: 100rpx;
    text-align: center;
  }
</style>
